import React from 'react';
import { motion } from 'framer-motion';
type SectionHeaderProps = {
  eyebrow: string;
  title: string;
  description?: string;
  centered?: boolean;
  light?: boolean;
};
export function SectionHeader({
  eyebrow,
  title,
  description,
  centered = false,
  light = false
}: SectionHeaderProps) {
  return <motion.div className={centered ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.35
  }} transition={{
    duration: 0.55
  }} data-id="element-30">
      <p className="mb-4 text-[11px] font-bold tracking-[0.22em] text-[#1D6FE8]" data-id="element-31">
        {eyebrow}
      </p>
      <h2 className={`text-3xl font-semibold leading-[1.05] tracking-[-0.04em] sm:text-5xl ${light ? 'text-white' : 'text-white'}`} data-id="element-32">
        {title}
      </h2>
      {description && <p className="mt-5 text-base leading-7 text-[#94A3B8]" data-id="element-33">{description}</p>}
    </motion.div>;
}